
import React from "react";
import { LearnerCourseData } from "@/hooks/useLearnerCourse";
import LearnerVideoSection from "@/components/learner/LearnerVideoSection";
import LearnerMaterialsSection from "@/components/learner/LearnerMaterialsSection";
import LearnerCompletionButton from "@/components/learner/LearnerCompletionButton";
import CourseDescription from "@/components/course-detail/CourseDescription";

interface LearnerCourseContentProps {
  courseData: LearnerCourseData;
  onCourseCompletion: () => void;
}

const LearnerCourseContent = ({ courseData, onCourseCompletion }: LearnerCourseContentProps) => {
  const { id, title, video_id, lesson_id, pdf_materials, is_completed, description } = courseData;

  return (
    <div className="max-w-4xl mx-auto px-4 space-y-8">
      {/* Course Title and Short Description */}
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-extrabold text-kaija-accent mb-2">{title}</h1>
        {courseData.short_description && (
          <p className="text-gray-700 text-base md:text-lg">{courseData.short_description}</p>
        )}
      </div>

      <LearnerVideoSection
        videoId={video_id}
        lessonId={lesson_id}
        title={title}
      />

      {/* Course full description section */}
      {description && (
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <CourseDescription description={description} />
        </div>
      )}

      {pdf_materials && pdf_materials.length > 0 && (
        <LearnerMaterialsSection
          pdfMaterials={pdf_materials}
        />
      )}

      {/* Only show completion status if the course is completed */}
      {is_completed && (
        <LearnerCompletionButton 
          courseId={id}
          isCompleted={is_completed}
          onCompleted={onCourseCompletion}
        />
      )}
    </div>
  );
};

export default LearnerCourseContent;
